import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { MatchingImportance } from '../../types/ApplicationQuestion';

interface MatchingImportancePillProps {
    importance: MatchingImportance;
    size?: 'small' | 'medium';
}

const MatchingImportancePill: React.FC<MatchingImportancePillProps> = ({ importance, size = 'small' }) => {
    const getColor = (): 'error' | 'warning' | 'success' | 'info' | 'default' => {
        switch (importance) {
            case MatchingImportance.CRITICAL:
                return 'error';      // Red
            case MatchingImportance.HIGH:
                return 'warning';    // Orange
            case MatchingImportance.MEDIUM:
                return 'success';    // Green
            case MatchingImportance.LOW:
                return 'info';       // Blue
            default:
                return 'default';
        }
    };

    const getLabel = () => {
        if (importance === MatchingImportance.NOT_USED) {
            return 'Not Used';
        }
        // Convert enum value to capitalized words (e.g., HIGH -> High, MEDIUM -> Medium)
        const formatted = importance.toString().toLowerCase().replace('_', ' ');
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    };

    return (
        <Tooltip title={`Matching Importance: ${getLabel()}`}>
            <Chip
                label={getLabel()}
                size={size}
                color={getColor()}
                sx={{
                    height: size === 'small' ? 20 : 24,
                    '& .MuiChip-label': {
                        px: 0.75,
                        fontSize: size === 'small' ? '0.65rem' : '0.75rem',
                        fontWeight: 500
                    }
                }}
            />
        </Tooltip>
    );
};

export default MatchingImportancePill;
